import { withStyles } from "@material-ui/core";
import { CheckCircleOutline } from "@material-ui/icons";

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: 232,
    minHeight: 90,
    borderRadius: 8,
    border: `1px solid ${theme.AppBGColor}`
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '14px 14px 0px 14px',
    color: theme.dispatchPanelHeaderColor
  },
  value: {
    fontSize: 32,
    fontWeight: 600,
    margin: '0px 14px 14px 14px',
    color: theme.dispatchPanelLabelValueColor
  },
  checkIcon: {
    color: theme.palette.primary.main,
    fontSize: 24
  }
});

const Card = ({ label, value, classes }) => {
  return (
    <div className={classes.container}>
      <div className={classes.label}>
        {label}
        <CheckCircleOutline className={classes.checkIcon}/>
      </div>
      <div className={classes.value}>{value}</div>
    </div>
  );
};

export default withStyles(styles)(Card);
